import { accentBaseColor } from "../fast-design-system";
import { black, white } from "./color-constants";
import { contrast } from "./common";
/**
 * Function to derive accentForegroundCut from an input background and target contrast ratio
 */
const accentForegroundCutAlgorithm = (backgroundColor, targetContrast) => {
    return contrast(white, backgroundColor) >= targetContrast ? white : black;
};
/**
 * Factory to create a accent-foreground-cut function that operates on a target contrast ratio
 */
function accentForegroundCutFactory(targetContrast) {
    function accentForegroundCutInternal(arg) {
        return typeof arg === "function" || typeof arg === "string"
            ? (designSystem) => {
                return accentForegroundCutAlgorithm(typeof arg === "function" ? arg(designSystem) : arg, targetContrast);
            }
            : accentForegroundCutAlgorithm(accentBaseColor(arg), targetContrast);
    }
    return accentForegroundCutInternal;
}
/**
 * Cut text for normal sized text, less than 18pt normal weight
 * @internal
 */
export const accentForegroundCut = accentForegroundCutFactory(4.5);
/**
 * Cut text for large sized text, greater than 18pt or 16pt and bold
 * @internal
 */
export const accentForegroundCutLarge = accentForegroundCutFactory(3);
